document.querySelectorAll('[data-review-list]').forEach((list) => {
  const select = list
    .closest('.product-reviews')
    ?.querySelector('.product-reviews__sort-select');

  if (!select) return;

  select.addEventListener('change', () => {
    const items = Array.from(list.children);

    items.sort((a, b) => {
      if (select.value === 'highest') {
        return Number(b.dataset.rating) - Number(a.dataset.rating);
      }
      if (select.value === 'lowest') {
        return Number(a.dataset.rating) - Number(b.dataset.rating);
      }
      return new Date(b.dataset.date) - new Date(a.dataset.date);
    });

    items.forEach((item) => list.appendChild(item));
  });
});
